import { AUTOS_SELL_PAGE_NAME } from 'Constants/sellLandingPage';

export const isOlxAutosSellPage = pgName => pgName === AUTOS_SELL_PAGE_NAME;
